export const allTags = [
  {
    name: 'high_priority',
    label: 'High Priority',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'delay',
    label: 'Delay',
    hasGenes: false,
    inTriage: true
  },
  {
    name: 'go',
    label: 'GO information (Primary Literature)',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'classical_phenotype',
    label: 'Classical phenotype information (Primary Literature)',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'headline_information',
    label: 'Headline information (Primary Literature)',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'other_primary',
    label: 'Other primary information (Primary Literature)',
    hasGenes: true,
    inTriage: true,
    noComments: true
  },
  {
    name: 'reviews',
    label: 'Reviews',
    hasGenes: true,
    inTriage: true,
    noComments: true
  },
  {
    name: 'additional_literature',
    label: 'Additional Literature (Additional Literature)',
    hasGenes: true,
    inTriage: true,
    noComments: true
  },
  {
    name: 'htp_phenotype',
    label: 'HTP phenotype Data (Omics)',
    hasGenes: false,
    inTriage: true
  },
  {
    name: 'non_phenotype_htp',
    label: 'Other HTP Data (Omics)',
    hasGenes: false,
    inTriage: true
  },
  {
    name: 'homology_disease',
    label: 'Homology/Disease',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'ptm',
    label: 'Post-translational modifications',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'regulation_information',
    label: 'Regulation information',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'pathways',
    label: 'Pathways',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'gene_model',
    label: 'Gene model',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'engineering',
    label: 'Engineering',
    hasGenes: true,
    inTriage: true
  },
  {
    name: 'alleles',
    label: 'Alleles',
    hasGenes: true,
    inTriage: true
  },
  // {
  //   name: 'go_needs_review',
  //   label: 'GO needs review',
  //   hasGenes: false,
  //   inTriage: false
  // },
  // {
  //   name: 'headline_needs_review',
  //   label: 'Headline needs review',
  //   hasGenes: false,
  //   inTriage: false
  // },
  // {
  //   name: 'headline_reviewed',
  //   label: 'Headline reviewed',
  //   hasGenes: false,
  //   inTriage: false
  // },
  // {
  //   name: 'not_yet_curated',
  //   label: 'Not yet curated',
  //   hasGenes: false,
  //   inTriage: false
  // },
  // {
  //   name: 'paragraph_needs_review',
  //   label: 'Paragraph needs review',
  //   hasGenes: false,
  //   inTriage: false
  // },
  // {
  //   name: 'paragraph_not_needed',
  //   label: 'Paragraph not needed',
  //   hasGenes: false,
  //   inTriage: false
  // },
  // {
  //   name: 'phenotype_needs_review',
  //   label: 'Phenotype needs review',
  //   hasGenes: false,
  //   inTriage: false
  // },
  // {
  //   name: 'phenotype_uncuratable',
  //   label: 'Phenotype uncuratable',
  //   hasGenes: false,
  //   inTriage: false
  // },
  // {
  //   name: 'ptm',
  //   label: 'Post-translational modifications',
  //   hasGenes: false,
  //   inTriage: false
  // },
  // {
  //   name: 'fast_track',
  //   label: 'Fast Track',
  //   hasGenes: false,
  //   inTriage: false
  // }
];



// WEBPACK FOOTER //
// ./containers/curateLit/litConstants.js